import type { FC } from 'react'

import AssignmentIndIcon from '@mui/icons-material/AssignmentInd'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Toolbar from '@mui/material/Toolbar'
import useScrollTrigger from '@mui/material/useScrollTrigger'

import { LoginButton } from '../../auth/components/LoginButton'
import { CapoLogo } from '../../theme/components/CapoLogo'

export const LoginNavigation: FC = () => {
  const trigger = useScrollTrigger({ threshold: 0, disableHysteresis: true })

  return (
    <AppBar
      position="sticky"
      sx={
        trigger
          ? { background: 'white', elevation: 4 }
          : { background: 'transparent', boxShadow: 'none' }
      }
      id={trigger ? 'elevated' : 'flat'}
    >
      <Toolbar sx={{ color: 'black', backgroundColor: 'transparent' }}>
        <CapoLogo />

        <Box sx={{ flex: 1 }} />

        <Button
          href="https://mijnaansluiting.atlassian.net/wiki/spaces/Wiki/pages/40075267/Registreren+als+gebruiker+van+CAPO"
          target="_blank"
          rel="noreferrer"
          sx={{ color: 'black' }}
          color="secondary"
          startIcon={<AssignmentIndIcon />}
        >
          Registeren voor CAPO
        </Button>

        <LoginButton sx={{ color: 'black' }} />
      </Toolbar>
    </AppBar>
  )
}
